import React from 'react'
import noteImg from '../../../assets/images/icons/note.svg'
import { fixImgSrc } from '../../../utils/tools'
import { OrderPreview } from '../../../types/task'

interface Cprops {
  slide: OrderPreview
}

const ImageSlide: React.FC<Cprops> = ({ slide }) => {
  return <img className="slide-img" src={fixImgSrc(slide.image.url)} alt="preview" />
}

const AudioSlide: React.FC<Cprops> = ({ slide }) => {
  return (
    <div className="slide-audio-wrap">
      <img className="slide-audio-icon" src={noteImg} alt="icon" />
      <audio className="slide-audio" controls>
        <source src={fixImgSrc(slide.image.url)} type="audio/mpeg" />
      </audio>
    </div>
  )
}

const VideoSlide: React.FC<Cprops> = ({ slide }) => {
  return (
    <video className="slide-video" controls>
      <source src={fixImgSrc(slide.image.url)} type="video/mp4" />
    </video>
  )
}

const Slide: React.FC<Cprops> = ({ slide }) => {
  let fileType = ''

  // Try to get file type from name first
  if (slide.name && slide.name.includes('.')) {
    const [lastPart] = slide.name.split('.').reverse()
    fileType = lastPart
  } else if (slide.image && slide.image.url) {
    // If no extension in name, try to extract from URL
    const urlParts = slide.image.url.split('.')
    if (urlParts.length > 1) {
      fileType = urlParts.pop() || ''
      // Remove any query parameters
      fileType = fileType.split('?')[0]
    }
  }

  fileType = fileType.toLocaleLowerCase()

  if (fileType === 'mp4') {
    return <VideoSlide slide={slide} />
  }

  if (fileType === 'mp3') {
    return <AudioSlide slide={slide} />
  }

  if (['svg', 'jpg', 'jpeg', 'png'].includes(fileType)) {
    return <ImageSlide slide={slide} />
  }

  // Default to image if we still can't determine the type but we have an URL
  if (slide.image && slide.image.url) {
    return <ImageSlide slide={slide} />
  }

  return null
}

export default Slide
